import React, { Fragment } from 'react';
import { withSiteData } from 'react-static';
import styled from 'styled-components';
import em from 'polished/lib/helpers/em';
import { IPartners } from 'types/IPartners';
import { IOptions } from 'types/IOptions';
import { IPartner } from "types/IPartner";

const PartnerWrapper = styled.div`
  //padding-right: 3em;
`;

const PartnerText = styled.p`
  font-family: Flow-Poster-Bold;
  //font-size: 2.8em;
  font-size: 3.8em;
  line-height: ${em(4.8, 2.8)};
  max-width: 800px;
  text-transform: uppercase;
  
  a {
    text-decoration: none;
    font-family: Flow-Poster-Bold !important;
    font-feature-settings:"liga", "dlig";
    &:${props => props.theme.hoverProperty} {
      color: ${props => props.theme.highlightColor};
    }
  }
  
  @media only screen and (max-width: 1100px) {
    max-width: none;
  }
  
  @media (max-width: 900px) {
    font-size: ${38 / (900 * 0.01)}vw;
  }
  
  @media (max-width: 550px) {
    font-size: 2.8em;
  }
`;

interface Props {
  appLanguage: IAppLanguage;
  options: IOptions;
  partners: IPartners;
}

interface State {
  filteredPartners?: {[index: number]: IPartners};
}

class Partners extends React.Component<Props, State> {

  state: State;

  constructor(props: Props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this._setFilteredState();
  }

  componentWillReceiveProps() {
    this._setFilteredState();
  }



  render() {
    const {
      appLanguage,
      options,
      partners
    } = this.props;

    const {
      partners_texts: {
        main_partners_text,
        also_supported_by_text,
        media_partners_text
      }
    } = appLanguage ? options[appLanguage.code] : options['fi'];

    const isTherePartnersInThisPartnerLevel = (level: string): boolean => {
      return partners.filter(partner => partner.partner_level === level).length > 0;
    };

    if (appLanguage.code !== 'ru') {
      return (
        <PartnerWrapper>
          <PartnerText>
            {isTherePartnersInThisPartnerLevel('1') &&
              <Fragment>
                {`${main_partners_text} `}
                {this._renderPartnerGropup(1)}
              </Fragment>
            }
            {isTherePartnersInThisPartnerLevel('2') &&
              <Fragment>
                {`${also_supported_by_text} `}
                {this._renderPartnerGropup(2)}
              </Fragment>
            }
            {isTherePartnersInThisPartnerLevel('3') &&
              <Fragment>
                {`${media_partners_text} `}
                {this._renderPartnerGropup(3)}
              </Fragment>
            }
            {isTherePartnersInThisPartnerLevel('6') &&
              <Fragment>
                {`${appLanguage.code === 'fi' ? 'Tuotantokumppanit ovat' : 'Production Partners are'  } `}
                {this._renderPartnerGropup(6)}
              </Fragment>
            }
          </PartnerText>
        </PartnerWrapper>
      )
    } else {
      return (
        <PartnerWrapper>
          <PartnerText>
            {`${also_supported_by_text} `}
            {this._renderPartnerGropup(2)}
          </PartnerText>
        </PartnerWrapper>
      )
    }
  }

  private _renderPartnerGropup = (level: number) => {
    const {
      filteredPartners
    } = this.state;

    const isSupported = (partner: string): boolean => {
      let supportedInFont: string[] = [
        'Lapin Kulta',
        'Lapin Kulta Pure',
        'Bright',
        'Aalto University',
        'Aalto-yliopisto',
        'Oatly',
        'OP Financial Group',
        'Paulig',
        'Plan B',
        'Perlage',
        'Stopteltat',
        'Sun Effects',
        'Basso',
        'Clear Channel',
        'Helsingin Sanomat',
        'HS',
        'Resident Advisor',
        'Yandex Music',
        'Europe Plus',
        'Esquire Russia',
        'Buro 24/7',
        'Mixmag Russia',
        'The Village',
        'Seat',
        'Norwegian',
        'Reaktor',
        'Nordea',
        'Kryhma',
        'Kgroup',
        'Lumo',
        'Respublica',
        'Psychodaily',
        'Lanson',
        'Vallila',
        'Helsinki',
        'Vaasan',
        'Radio Helsinki',
        'Freefi',
        'CT',
        'Juhla Mokka',
        'Oddly',
        'Finnkino',
        'Polestar',
        "Samsung",
        "POOL",
        "Sky Production",
      ];
      return supportedInFont.indexOf(partner) !== -1;
    };

    const translatePartnerNamesToEnglish = (partner: string): string => {
      let translatableNames: string[] = [
        'OP Helsinki',
          'Creative Technology',
      ];
      if (translatableNames.indexOf(partner) !== -1) {
        switch(partner) {
          case 'OP Helsinki':
            partner = 'OP Financial Group';
            break;
          case 'Creative Technology':
            partner = 'CT'
                break;
        }
      }
      return partner;
    };

    const parsePartnerNameToLogo = (partner: string): string => {
      partner = translatePartnerNamesToEnglish(partner);
      if (!isSupported(partner)) {
        return partner;
      }
      return '[' + partner.replace(/[\. /-]+/g, '').toUpperCase() + ']';
    };

    if (filteredPartners && filteredPartners[level]) {
      const partnersLength = filteredPartners[level].length;
      return filteredPartners[level].map((partner: IPartner, idx: number) => {
          if ((partnersLength -1) > idx) {
            return [
              <a key={partner.title} href={partner.partner_url} target="_blank">{parsePartnerNameToLogo(partner.title)}</a>,
              <span key={`${level}_${idx}_spanner`}> / </span>,
            ];
          }
          else {
            return [
              <a key={`${level}_${idx}`} href={partner.partner_url} target="_blank">{parsePartnerNameToLogo(partner.title)}</a>,
              <span key={`${level}_${idx}_spanner`}> </span>,
            ];
          }
        }
      );
    }
    return null;
  };

  private _setFilteredState = (): void => {
    const {
      partners,
    } = this.props;

    let filteredPartners: any = {};
    partners.forEach((partner) => {
      if (!filteredPartners[partner.partner_level]) filteredPartners[partner.partner_level] = [];
      filteredPartners[partner.partner_level].push(partner);
    });

    this.setState({
      filteredPartners
    });
  }
}

export default withSiteData(Partners);



// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/components/partners/Partners.tsx